<template>
  <div class="ui-bar" :class="{ 'ui-bar--is-tall': isTall }">
    <div class="ui-bar__elements-list">
      <slot></slot>
    </div>
    <slot name="progress-bar"></slot>
  </div>
</template>

<script>
export default {
  props: {
    isTall: Boolean
  }
}
</script>

<style lang="scss">
.ui-bar {
  & {
    background-color: $white-bis;
    border-top: 1px solid $grey-lighter;
    padding: $space-12px $space-16px;

    &--is-tall {
      padding-top: $space-16px;
      padding-bottom: $space-16px;
    }

    @include tablet {
      padding-left: $space-24px;
      padding-right: $space-24px;
    }

    @include fullhd {
      padding: $space-16px $space-32px;

      &--is-tall {
        padding-top: $space-24px;
        padding-bottom: $space-24px;
      }
    }

    @media print {
      background: none !important;
      padding: 0 !important;
    }
  }

  &__elements-list {
    & > .ui-bar-element {
      margin-top: $space-16px;
      &:first-child {
        margin-top: 0;
      }
    }
    
    @include tablet {
      display: flex;
      align-items: stretch;
      flex-wrap: wrap;
      column-gap: $space-16px;
      row-gap: $space-16px;

      & > .ui-bar-element {
        margin-top: 0;
      }
    }

    @include fullhd {
      flex-wrap: nowrap;
    }

    
  }
}
</style>